export * from './csv'
export * from './documentTitle'
export * from './returnUrl'

export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener, noreferrer')
}
